/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-restricted-globals */
import { AlertSnackBar } from "components/AlertSnackBar";
import { PageRedirect } from "features/landingPage/PageRedirect";
import { DiversityAtCloudSangha } from "features/landingPage/sep22/DiversityAtCloudSangha";
import { InterestGroupFlow } from "features/member/interestGroups/InterestGroupFlow";
import { NewMemberOnboarding } from "features/member/onboarding/NewMemberOnboarding";
import { TeachersPage } from "features/member/teachers/TeachersPage";
import NotFoundPage from "features/pages/NotFoundPage";
import { VisitorDonate } from "features/pages/VisitorDonate";
import { VisitorDonateSuccess } from "features/pages/VisitorDonateSuccess";
import { SignupFlow } from "features/signup";
import { SignupSuccess } from "features/signup/SignupSuccess";
import { TeacherPostSessionFlow } from "features/teacherPostSessionFlow/TeacherPostSessionFlow";
import { ModalRoutes } from "ModalRoutes";
import { Route, Switch, useLocation } from "react-router";
import { routes } from "./app/routes";
import { AuthRoute } from "./features/auth/AuthRoute";
import { Login } from "./features/auth/Login";
import CommunityPage from "./features/community/Community";
import ContactPage from "./features/contact/ContactPage";
import MemberZone from "./features/member/MemberZone";
import FAQPage from "./features/pages/FAQPage";
import GuidelinesPage from "./features/pages/GuidelinesPage";
import MaintenancePage from "./features/pages/MaintenancePage";
import PrivacyPolicyPage from "./features/pages/PrivacyPolicyPage";
import TermsOServicePage from "./features/pages/TermsOfServicePage";
import { SetupInterestGroupFlow } from "features/member/interestGroups/SetupInterestGroupFlow";

/**
 * WARNING: If you add new top level routes to the react app, they will work locally but will NOT work in production
 * unless you configure our load balancer to recognize them. See "Site structure and routing" in the README for instructions
 */

export const Routes = (props: any) => {
    const maintenance = false;

    const location = useLocation();

    return (
        <>
            <AlertSnackBar />

            <Switch>
                <Route path={routes.community()} component={CommunityPage} />
                <Route path={routes.communityGuidelines()} component={GuidelinesPage} />
                <Route path={routes.contactUs()} component={ContactPage} />
                <Route path={routes.faq()} component={FAQPage} />
                <Route path={routes.privacyPolicy()} component={PrivacyPolicyPage} />
                <Route path={routes.termsOfService()} component={TermsOServicePage} />

                <AuthRoute
                    path={routes.signupSuccess()}
                    component={!maintenance ? SignupSuccess : MaintenancePage}
                />

                <Route
                    path={routes.signup()}
                    component={!maintenance ? SignupFlow : MaintenancePage}
                />
                <Route path={routes.login()} component={!maintenance ? Login : MaintenancePage} />

                <AuthRoute path={routes.memberOnboarding()} component={NewMemberOnboarding} />
                <Route path={routes.setupAllInterestGroups()} component={SetupInterestGroupFlow} />
                <Route path={routes.allInterestGroups()} component={InterestGroupFlow} />

                <AuthRoute
                    path={routes.memberZone()}
                    component={!maintenance ? MemberZone : MaintenancePage}
                />

                <AuthRoute
                    path={routes.teacherPostSession(":sanghaId")}
                    component={!maintenance ? TeacherPostSessionFlow : MaintenancePage}
                />

                <Route exact path={routes.diversity()} component={DiversityAtCloudSangha} />

                {/* Webflow pages */}
                <Route
                    exact
                    path={routes.home()}
                    render={(props) => <PageRedirect {...props} pageName="landingPage" />}
                />
                <Route
                    exact
                    path={routes.testimonials()}
                    render={(props) => <PageRedirect {...props} pageName="testimonials" />}
                />
                <Route
                    exact
                    path={routes.teacherSection()}
                    render={(props) => <PageRedirect {...props} pageName="teacherSection" />}
                />
                <Route
                    path={routes.about()}
                    render={(props) => <PageRedirect {...props} pageName="aboutPage" />}
                />
                <Route
                    path={routes.careers()}
                    render={(props) => <PageRedirect {...props} pageName="careersPage" />}
                />

                <Route path={routes.visitorDonate()} component={VisitorDonate} />
                <Route path={routes.visitorDonationSuccess()} component={VisitorDonateSuccess} />

                <Route path={routes.publicTeachersPage()} component={TeachersPage} />

                <Route component={NotFoundPage} />
            </Switch>

            <ModalRoutes />
        </>
    );
};
